interface IMenuItem {
  title: string;
  url: string;
}

export default function getSubNavigationByLocation(
  city: string,
) {
  const baseUrl = `/interior-designers/${city}`;

  const items: IMenuItem[] = [{
    title: 'Team',
    url: `${baseUrl}/team`
  }, {
    title: 'Portfolio',
    url: `${baseUrl}/portfolio`
  }, {
    title: 'Services',
    url: `${baseUrl}/services`
  }, {
    title: 'Reviews',
    url: `${baseUrl}/reviews`
  }, {
    title: 'Cost',
    url: `${baseUrl}/cost`
  }];

  return items;
}
